import { render, staticRenderFns } from "./Credit.Detail.vue?vue&type=template&id=12601aa0&"
import script from "./Credit.Detail.vue?vue&type=script&lang=js&"
export * from "./Credit.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports